<div *ngIf="!template || reloadingTemplate" class="spinner-container">
    <app-loading-spinner></app-loading-spinner>
</div>
<div *ngIf="template && !reloadingTemplate" class="create-booking-pre-confirmation-main-container">
    <div [innerHTML]="template.beforePriceTable | safeHtml"></div>
    <p-table [value]="products">
        <ng-template pTemplate="header">
            <tr>
                <th width="120">
                    Type
                </th>
                <th>
                    Remarks
                </th>
                <th>
                    Price {{bookingService.booking.preConfirmation!.baseCurrency.symbol}}
                </th>
                <th *ngIf="bookingService.booking.preConfirmation!.secondCurrency">
                    Price {{bookingService.booking.preConfirmation!.secondCurrency.symbol}}
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-product>
            <tr>
                <td>
                    {{product.productType.name}}
                </td>
                <td>
                    {{product.description}}
                </td>
                <td *ngIf="product.amountInBase">
                    {{product.amountInBase}}
                </td>
                <td *ngIf="bookingService.booking.preConfirmation!.secondCurrency && product.amountInSecond">
                    {{product.amountInSecond}}
                </td>
            </tr>
        </ng-template>
    </p-table>
    <p-table [value]="totals">
        <ng-template pTemplate="body" let-item>
            <tr>
                <td  width="120">
                    {{item.label}}
                </td>
                <td></td>
                <td>
                    {{item.valueInBase.toFixed(2)}}
                </td>
                <td *ngIf="bookingService.booking.preConfirmation!.secondCurrency">
                    {{item.valueInSecond.toFixed(2)}}
                </td>
            </tr>
        </ng-template>
    </p-table>
    <div class="create-booking-pre-confirmation-price-include-containers">
        <div class="price-include-box">
            <h4>
                Prices include
            </h4>
            <div [innerHTML]="bookingService.booking.preConfirmation!.priceIncludes | safeHtml"></div>
        </div>
        <div class="price-include-box">
            <h4>
                Prices do not include
            </h4>
            <div [innerHTML]="bookingService.booking.preConfirmation!.priceNotIncludes | safeHtml"></div>
        </div>
    </div>
    <div *ngIf="bookingService.booking.preConfirmation!.middleComment">
        {{bookingService.booking.preConfirmation!.middleComment}}
    </div>
    <div [innerHTML]="template.afterPriceTable | safeHtml">
    </div>


    <p-button (onClick)="postPreConf()" label="Validate this pre confirmation"></p-button>
    This is a confirmation
    <p-checkbox [binary]="true" [(ngModel)]="isConfirmed" (onChange)="confirmationChange($event.checked)"></p-checkbox>
    Use old pre confirmation style
    <p-checkbox [binary]="true" [(ngModel)]="useLegacy" (onChange)="confirmationChange($event.checked)"></p-checkbox>
</div>